import { ExamLevels } from '../../types/enum';
import {
	getSubjectsByStringApi,
	getSubjectsByIdApi,
	getSubjectsByNameApi,
} from './../../api/bedrockAPI';
import { getCurrentAcademicYear } from '../../utils/academicYear';

export const getSubject = async (
	benchmarkId: number,
	subjectString: string,
	options?: { academicYear?: number }
): Promise<SubjectBedrock | null> => {
	try {
		// Make the API call to fetch the subject
		const response = await getSubjectsByStringApi(
			benchmarkId,
			subjectString,
			options?.academicYear ?? getCurrentAcademicYear()
		);

		// Check if response is valid
		if (!response || !response.hasResponse || !response.responseObject) {
			throw new Error('Subject not found or invalid response.');
		}

		// Extract subject data from response
		const subjectData = response.responseObject;

		// Map subject data to simplified object structure
		const subject: SubjectBedrock = {
			alpsSubjectId: subjectData.alpsSubjectId ?? 0,
			value: subjectData.value,
			display: subjectData.display ?? '',
			compact: subjectData.compact,
			reportLevel: ExamLevels[subjectData.reportLevel as keyof typeof ExamLevels],
			order: subjectData.order,
			qanSyllList: subjectData.qanSyllList,
		};

		return subject;
	} catch (error) {
		console.error('Error fetching subject:', error);
		return null;
	}
};

export const getSubjectsById = async (
	subjectsList: number[]
): Promise<Array<SubjectBedrock> | null> => {
	try {
		const response = await getSubjectsByIdApi(subjectsList);

		// Check if response is valid
		if (!Array.isArray(response.responseObject)) {
			console.warn('Invalid response. Expected an array.');
			return [];
		}

		// Filter subjects based on subjectsList
		const filteredSubjects = response.responseObject.filter((subject) =>
			subjectsList.includes(subject.alpsSubjectId)
		);

		return filteredSubjects;
	} catch (error) {
		console.error('Error fetching subjects:', error);
		return null;
	}
};

export const getSubjectsByName = async (
	subjectsList: string[],
	benchmarkId: number,
	options?: { academicYear?: number; fallbackToAllYears?: boolean }
): Promise<Array<SubjectBedrock> | null> => {
	try {
		const response = await getSubjectsByNameApi(
			subjectsList,
			benchmarkId,
			options?.academicYear ?? getCurrentAcademicYear(),
			options?.fallbackToAllYears ?? false
		);
		// Check if response is valid
		if (!Array.isArray(response.responseObject)) {
			console.warn('Invalid response. Expected an array.');
			return [];
		}

		return response.responseObject;
	} catch (error) {
		console.error('Error fetching subjects:', error);
		return null;
	}
};
